export const ADMIN = "admin";
export const USER = "user";
export const SUPERUSER = "superuser";
export const OPERATOR = "operator";
